import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { lazyWithRetry } from 'root/lib/utilityFunctions';

const IconSvg = React.memo(({ name }) => {
  const SvgComponent = lazyWithRetry(() => import(`../../assets/svgs/icons/${name}.svg`));
  return <Suspense fallback={<svg />}><SvgComponent /></Suspense>;
});

IconSvg.propTypes = {
  name: PropTypes.string.isRequired,
};

export default IconSvg;
